<template>
  <!--
    主页面模板，包含顶部功能卡片区和下方智慧社区内容区。
  使用 Element Plus 的 el-row、el-col、el-card 进行布局。
  （注：el-row、el-col、el-card 都是 Element Plus UI 组件库自带的布局和卡片组件，不是本项目自定义的，需在 package.json 依赖 element-plus）
  每个卡片点击后会跳转到对应的功能页面。
  -->
  <div class="dashboard-container">
    <!-- 包裹一层做缩放 -->
    <div class="dashboard-scale">
      <el-row
        :gutter="20"
        class="data-cards"
      />

      <div class="wisdom-community-section">
        <!--
        WisdomCommunityScreen 是一个自定义的 Vue 子组件。
        这里像写 HTML 标签一样直接写组件名，就能把它渲染出来。
        key="wisdom-community" 是 Vue 的虚拟 DOM 优化用的，保证组件唯一性。
        style="display: block; visibility: visible;" 是内联样式，强制让这个组件显示出来（一般可省略）。
        这样写的效果就是：在这个位置完整显示 WisdomCommunityScreen 组件的内容。
      -->
        <WisdomCommunityScreen
          key="wisdom-community"
          style="display: block; visibility: visible;"
        />
      </div>
    </div>
  </div>
</template>

<script>
// 组合式 API 引入
import { ref, onMounted, nextTick } from 'vue'
// 引入 vue-router 的 useRouter，用于页面跳转
import { useRouter } from 'vue-router'
// 引入智慧社区子页面组件
import WisdomCommunityScreen from './WisdomCommunityScreen.vue'

export default { // 这是一个 Vue 组件的默认导出对象，用于定义组件的选项，可以被 Vue 实例化，被其他组件引用
  name: 'MainDashboard', // 组件名称，便于调试和递归调用
  components: {
    WisdomCommunityScreen // 注册子组件，使其能在模板中直接使用
  },
  setup() { // 组合式 API 的入口函数
    // 1. 获取路由实例，用于页面跳转
    const router = useRouter()
    // 2. 定义响应式变量，控制智慧社区内容显示（可扩展）
    const showWisdomCommunity = ref(true)
    // 3. 跳转到指定路由页面的方法，参数为路由名称
    const navigateTo = (routeName) => {
      router.push({ name: routeName }) // 编程式导航，跳转到对应页面
    }
    // 4. 生命周期钩子，组件挂载后执行（可做 DOM 操作或初始化）
    onMounted(() => {
      // 使用 requestAnimationFrame 和 nextTick 确保 DOM 渲染完成后再执行操作
      requestAnimationFrame(() => {
        nextTick(() => {
          // 这里可做动画或数据初始化
        })
      })
    })
    // 5. 向模板暴露变量和方法，供 <template> 使用
    return {
      showWisdomCommunity,
      navigateTo
    }
  }
}
</script>
<style scoped>
/*
  页面样式区：
  1. .dashboard-container 控制整体布局和缩放
  2. .data-cards、.data-card 控制卡片布局和交互效果
  3. .wisdom-community-section 控制下方嵌入内容样式
  4. :deep() 用于 Element Plus 组件深度样式定制
*/
/* .dashboard-container {
  background-color: #000000;
  color: white;
  padding: 10px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  transform: scale(0.85);
  transform-origin: top left;
  width: 117.65%; /* 100% / 0.85 ≈ 117.65%，实现缩放适配大屏 
  height: 117.65%;
} */

.dashboard-container {
  width: 100%;            /* 容器宽度占满整个父级 */
  height: 100%;           /* 占据 flex 父容器的剩余空间 */
  padding: 0;             /* 移除内边距，使大屏铺满 */
  box-sizing: border-box; /* 让padding和border包含在width/height内，布局更可控 */
  background: #000;       /* 背景色为黑色，适合大屏数据可视化 */
  color: #fff;            /* 文字颜色为白色，保证对比度和可读性 */
  overflow: hidden;       /* 隐藏页面本身的滚动条，防止出现多余滚动 */
  flex: 1;                /* 作为 flex 子项，占据 App.vue 中的剩余高度 */
  display: flex;
  flex-direction: column;
}

/* 内层：真正做缩放的那一层 */
/* 用 CSS Grid 把页面分成：上=卡片(自适应高) 下=内容(占满剩余) */
.dashboard-scale {
  width: 100%;            /* 占满父容器宽度 */
  height: 100%;           /* 占满父容器高度 */
  display: grid;          /* 使用 CSS Grid 布局，方便分区 */
  grid-template-rows: auto 1fr; /* 上面一行高度自适应（卡片区），下面一行占满剩余空间（内容区） */
}

/* 上面那排卡片 */
.data-cards {
  margin: 0 0 6px 0;
}

.data-card {
  border: 1px solid rgba(24, 144, 255, 0.6);
  border-radius: 4px;
  background-color: #000000;
  box-shadow: 0 0 20px rgba(24, 144, 255, 0.4), inset 0 0 25px rgba(24, 144, 255, 0.15);
  color: white;
  cursor: pointer;
  transition: transform 0.3s;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50px;
}

.data-card:hover {
  transform: translateY(-5px); /* 鼠标悬停上浮效果 */
}

.card-content {
  text-align: center;
  padding: 2px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.big-number {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 10px;
}

.small-text {
  font-size: 16px;
  color: white;
}

.charts-row {
  margin-bottom: 20px;
}

.chart-card {
  background-color: #000000;
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(24, 144, 255, 0.4), inset 0 0 25px rgba(24, 144, 255, 0.15);
  color: white;
  padding: 15px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.chart-container {
  width: 100% !important;
  height: 300px !important;
  min-height: 300px !important;
  position: relative;
  background: transparent;
  overflow: hidden;
  display: block;
  box-sizing: border-box;
}

/* 添加全局样式穿透，定制 Element Plus 组件内部样式 */
:deep(.el-card__body) {
  height: 100%;
  padding: 8px !important;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:deep(.el-col) {
  height: 100%;
}

/* 下半区容器：**一定要**允许在 grid 中收缩，否则会把外层又撑高 */
.wisdom-community-section {
  background: #000;              /* 设置背景为黑色，统一风格 */
  margin: 0;                    /* 移除外边距 */
  width: 100%;                   /* 宽度占满父容器 */
  background-color: #000000;      /* 再次设置背景色，确保优先级（可合并） */
  border: none;                  /* 去除边框 */
  border-radius: 0;              /* 移除圆角以铺满 */
  color: white;                  /* 文字颜色为白色 */
  padding: 0;                    /* 移除内边距 */
  box-sizing: border-box;        /* 详细解释：让padding和border都包含在width/height内。即：元素的总宽度/高度=width/height本身，不会因为加了padding或border而变大。这样布局更可控，内容不会溢出容器。是前端开发推荐的写法。 */

  height: auto;                  /* 高度自适应内容 */
  min-height: 0;                 /* 关键：允许在 grid 布局中收缩，不撑高外层 */
  overflow: hidden;              /* 隐藏溢出内容，滚动不在这一层发生 */
  flex: 1 1 auto;                /* 如果父级是flex布局，自动占据剩余空间 */
}

/* 人员管理、地理位置、事件处理、社区设备、社区智慧招聘卡片底纹 */
.people-management-card, .location-card, .event-card, .device-card, .recruitment-card {
  background: linear-gradient(135deg, #122a44, #0a1a2a) !important;
  border: none !important;
}

/* 去除社区智慧招聘卡片右上角的白色标记 */
.recruitment-card::after {
  display: none !important;
}
</style>